import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHead, Panel } from "@/pages/vendor/Shell";

export function AdminOverview() {
  const [d, setD] = useState<any>(null);
  useEffect(() => { api.get("/admin/overview").then((r) => setD(r.data)); }, []);
  if (!d) return <p className="text-muted-foreground">Loading...</p>;
  const stats = [["Vendors", d.vendors], ["Suspended vendors", d.suspended_vendors], ["Attendees", d.attendees], ["Leads", d.leads],
    ["Consent records", d.consents], ["Active events", d.events], ["Paid checkouts", d.paid_transactions]];
  return (
    <div>
      <PageHead eyebrow="Platform" title="Overview" />
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        {stats.map(([k, v]) => (
          <Panel key={k} data-testid={`admin-stat-${String(k).toLowerCase().replace(/\s+/g, "-")}`}>
            <p className="text-xs uppercase tracking-wider text-muted-foreground">{k}</p><p className="mt-2 font-mono text-3xl">{v}</p>
          </Panel>
        ))}
      </div>
      <Panel className="mt-4" data-testid="admin-plan-breakdown">
        <h3 className="mb-3 font-semibold">Vendors by plan</h3>
        <div className="flex flex-wrap gap-3">{Object.entries(d.by_plan).map(([k, v]: any) => <span key={k} className="rounded-sm bg-muted px-3 py-1.5 text-sm capitalize">{k}: <b>{v}</b></span>)}</div>
      </Panel>
    </div>
  );
}

export function AdminAudit() {
  const [rows, setRows] = useState<any[]>([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHead eyebrow="Admin only" title="Audit log" />
      <Panel className="overflow-x-auto p-0" data-testid="admin-audit-table">
        <table className="w-full text-sm">
          <thead className="bg-muted text-left text-xs uppercase text-muted-foreground"><tr><th className="p-3">When</th><th className="p-3">Who</th><th className="p-3">Action</th><th className="p-3">Target</th><th className="p-3">Detail</th></tr></thead>
          <tbody className="divide-y">{rows.map((r) => (
            <tr key={r.id}><td className="p-3 text-xs">{new Date(r.created_at).toLocaleString()}</td><td className="p-3">{r.actor_email}</td>
              <td className="p-3 font-mono text-xs">{r.action}</td><td className="p-3 text-xs">{r.target}</td><td className="p-3 text-xs text-muted-foreground">{r.detail}</td></tr>
          ))}</tbody>
        </table>
        {rows.length === 0 && <p className="p-6 text-center text-sm text-muted-foreground">No admin actions yet.</p>}
      </Panel>
    </div>
  );
}
